
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import ImpfDbImpfstoffeDetail from '@/components/Impfdb/ImpfDbImpfstoffeDetail.vue';
    import ImpfDbImpfstoff from '@/types/ImpfDbImpfstoff';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            ImpfDbImpfstoffeDetail,
        },
        computed: {
            ...mapState('impfdb', ['dialogs', 'loaders', 'impfstoffe']),
        },
        methods: {
            ...mapActions('impfdb', ['loadImpfstoffe']),
            ...mapMutations('impfdb', ['setDialogsDetail']),
        },
    })
    export default class ImpfDbImpfstoffe extends Vue {
        public loadImpfstoffe!: () => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public impfstoff = new ImpfDbImpfstoff();
        public search = '';

        public get headers(): DataTableHeaders<ImpfDbImpfstoff> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Impfstoffnummer', value: 'impfstoffnr' },
                { text: 'Bezeichnung', value: 'bezeichnung' },
            ];
        }

        public mounted(): void {
            this.loadImpfstoffe();
        }

        public onClickEdit(impfstoff: ImpfDbImpfstoff): void {
            this.impfstoff = new ImpfDbImpfstoff(impfstoff);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.impfstoff = new ImpfDbImpfstoff();
            this.setDialogsDetail(true);
        }
    }
